import React, { useState } from "react";
import { addproduct } from "../redux/product/actions";
import { useDispatch } from "react-redux";

export default function Form() {
  const dispatch = useDispatch();
  const [product, setProduct] = useState({});

  function handleInputChange(e) {
    e.preventDefault();

    const value = e.target.value;
    const name = e.target.name;

    setProduct({
      ...product,
      product_id: Date.now(),
      [name]: value,
    });
  }

  function handleSubmit(e) {
    e.preventDefault();
    dispatch(addproduct({...product, total_product: product.quantity}));
    e.target.reset()
  }

  return (
    <div>
      <div className="formContainer">
        <h4 className="formTitle">Add New Product</h4>
        <form
          onSubmit={handleSubmit}
          className="space-y-4 text-[#534F4F]"
          id="lws-addProductForm"
        >
          <div className="space-y-2">
            <label htmlFor="lws-inputName">Product Name</label>
            <input
              className="addProductInput"
              id="lws-inputName"
              type="text"
              required
              name="title"
              onChange={(e) => handleInputChange(e)}
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="lws-inputCategory">Category</label>
            <input
              className="addProductInput"
              id="lws-inputCategory"
              type="text"
              required
              name="category"
              onChange={(e) => handleInputChange(e)}
            />
          </div>

          <div className="space-y-2">
            <label htmlFor="lws-inputImage">Image Url</label>
            <input
              className="addProductInput"
              id="lws-inputImage"
              type="text"
              required
              name="url"
              onChange={(e) => handleInputChange(e)}
            />
          </div>

          <div className="grid grid-cols-2 gap-8 pb-4">
            <div className="space-y-2">
              <label htmlFor="ws-inputPrice">Price</label>
              <input
                className="addProductInput"
                type="number"
                id="lws-inputPrice"
                required
                name="price"
                onChange={(e) => handleInputChange(e)}
              />
            </div>

            <div className="space-y-2">
              <label htmlFor="lws-inputQuantity">Quantity</label>
              <input
                className="addProductInput"
                type="number"
                id="lws-inputQuantity"
                required
                name="quantity"
                onChange={(e) => handleInputChange(e)}
              />
            </div>
          </div>

          <button type="submit" id="lws-inputSubmit" className="submit">
            Add Product
          </button>
        </form>
      </div>
    </div>
  );
}
